import { IImage, LinkComponentTypes, LinkTarget, NavigationItem, SubLinkLinkIconType } from "../types/common";

export type NavLinkListItem = {
  href: string;
  text: string;
  description?: string;
  target: LinkTarget;
  isExternal?: boolean;
  icon?: IImage;
  subLinks?: {
    text: string;
    href: string;
    target: LinkTarget;
    description?: string;
    icon?: IImage;
  }[];
  size?: "sm" | "md";
};

export type NavLink = {
  href: string;
  text: string;
  target: LinkTarget;
  isExternal?: boolean;
  list?: NavLinkListItem[];
  promotion?: {
    title: string;
    banner?: IImage;
    subtitle?: string;
    description?: string;
    href?: string;
    target?: LinkTarget;
  }[];
  size?: "sm" | "md";
};

type NavigationKey = "home" | "time-deposit" | "savings-account";

export const navigationsMap: Record<NavigationKey | string, Pick<NavLink, "href">> = {
  home: {
    href: "/",
  },
  business: {
    href: "/business",
  },
  vip: {
    href: "/vip",
  },
  contacts: {
    href: "/contacts",
  },
  "about-us": {
    href: "/about-us",
  },
  blog: {
    href: "/blog",
  },
};

export const getLinksFromNavData = (data: NavigationItem[], useDefaultHref = false): NavLink[] => {
  return data.map((item) => {
    let href = "#";
    let target: LinkTarget = "_self";
    let isExternal = false;
    let list = null;

    if (item.__component === LinkComponentTypes.NavLink) {
      href = useDefaultHref ? item.to : navigationsMap[item.to]?.href || href;
    }

    if (item.__component === LinkComponentTypes.ExternalLink) {
      href = item.href;
      isExternal = true;
      target = item.target || target;
    }

    if (item.__component === LinkComponentTypes.LinkList) {
      href = "";
      list = {
        list:
          item.list &&
          getLinksFromNavData(
            item.list.map((nestedLink) => ({
              ...nestedLink,
              __component: LinkComponentTypes.ExternalLink,
            })),
            true,
          ),
      };
    }

    return {
      text: item.text,
      href,
      target,
      isExternal,
      icon: (item as any).icon,
      description: (item as any).description,
      subLinks: (item as any).subLinks,
      promotion: (item as any)?.promotion,
      size: (item as any)?.size,
      ...list,
    };
  });
};
